import { createAction } from "@reduxjs/toolkit";
export const ConfigurationActionType = {
    ReplaceConfiguration: "replace-configuration",
    UpdateAttributeValue: "update-attribute-value",
    SetCfgNotice: "set-cfg-notice",
    SetProblemDetails: "set-problem-details",
    SetSessionId: "set-session-id",
    IncrementOpenRequests: "increment-open-requests",
    DecrementOpenRequests: "decrement-open-requests",
    SetLanguage: "set-language",
    SetPath: "set-path",
    SetBaseUrl: "set-base-url",
    SetApiKey: "set-api-key",
    AddSelector: "add-selector",
    RemoveSelector: "remove-selector",
    SetSelectors: "set-selectors",
    SetSelectorDefaults: "set-selector-defaults",
    AddSubscriber: "add-subscriber",
    RemoveSubscriber: "remove-subscriber",
    ResetAll: "reset-all",
    AddNavigation: "add-navigation",
    RemoveNavigation: "remove-navigation",
    ResetNavigationPath: "reset-navigation-path",
    ResetNavigationState: "reset-navigation-state",
    SetNavigationItems: "set-navigation-items",
    ToggleNavigationItem: "toggle-navigation-item",
};
export { ConfigurationActionType as EcsActionType };
/**
 * Server side update of cfg object
 */
export const replaceConfiguration = createAction(ConfigurationActionType.ReplaceConfiguration, (configuration, syncState) => ({
    payload: configuration,
    meta: { syncState },
}));
/**
 * Client side update of cfg object
 */
export const updateAttributeValue = createAction(ConfigurationActionType.UpdateAttributeValue, (attributeChange) => ({
    payload: attributeChange,
}));
export const resetAll = createAction(ConfigurationActionType.ResetAll);
export const setProblemDetails = createAction(ConfigurationActionType.SetProblemDetails, (problemDetails) => ({
    payload: problemDetails,
}));
export const setCfgNotice = createAction(ConfigurationActionType.SetCfgNotice, (notice) => ({
    type: ConfigurationActionType.SetCfgNotice,
    payload: notice,
}));
export const setSessionId = createAction(ConfigurationActionType.SetSessionId, (sessionId) => ({
    payload: sessionId,
}));
export const incrementOpenRequests = createAction(ConfigurationActionType.IncrementOpenRequests);
export const decrementOpenRequests = createAction(ConfigurationActionType.DecrementOpenRequests);
export const setPath = createAction(ConfigurationActionType.SetPath, (payload) => ({
    type: ConfigurationActionType.SetPath,
    payload,
}));
export const addNavigation = createAction(ConfigurationActionType.AddNavigation, (payload) => ({ payload }));
export const removeNavigation = createAction(ConfigurationActionType.RemoveNavigation, (payload) => ({ payload }));
export const resetSingleNavigationPath = createAction(ConfigurationActionType.ResetNavigationPath, (payload) => ({ payload }));
export const resetNavigationState = createAction(ConfigurationActionType.ResetNavigationState);
export const setNavigationItems = createAction(ConfigurationActionType.SetNavigationItems, (items) => ({
    payload: items,
}));
export const toggleNavigationItem = createAction(ConfigurationActionType.ToggleNavigationItem, (item, enable) => ({
    payload: { item, enable },
}));
export const setSelectors = createAction(ConfigurationActionType.SetSelectors, (selectors) => ({
    payload: selectors,
}));
export const addSelector = createAction(ConfigurationActionType.AddSelector, (selector) => ({
    type: ConfigurationActionType.AddSelector,
    payload: selector,
}));
export const removeSelector = createAction(ConfigurationActionType.RemoveSelector, (selector) => ({
    type: ConfigurationActionType.RemoveSelector,
    payload: selector,
}));
export const setSelectorDefaults = createAction(ConfigurationActionType.SetSelectorDefaults, (selector) => ({
    type: ConfigurationActionType.SetSelectorDefaults,
    payload: selector,
}));
export const addSubscriber = createAction(ConfigurationActionType.AddSubscriber, (options) => ({
    type: ConfigurationActionType.AddSubscriber,
    payload: options,
}));
export const removeSubscriber = createAction(ConfigurationActionType.RemoveSubscriber, (options) => ({
    type: ConfigurationActionType.RemoveSubscriber,
    payload: options,
}));
//# sourceMappingURL=actions.js.map